import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Property } from '@/types/revenue-manager';

interface AddPropertyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAdd: (property: Omit<Property, 'id'>) => void;
}

export function AddPropertyDialog({ open, onOpenChange, onAdd }: AddPropertyDialogProps) {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [basePrice, setBasePrice] = useState(150);
  const [roomCount, setRoomCount] = useState(100);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAdd({ name, location, basePrice, roomCount });
    setName('');
    setLocation('');
    setBasePrice(150);
    setRoomCount(100);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add New Property</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="flex flex-col flex-1 overflow-hidden">
          <DialogBody className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="name">Property Name <span className="text-destructive">*</span></Label>
              <Input
                id="name"
                placeholder="e.g., Downtown Hotel"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="location">Location <span className="text-destructive">*</span></Label>
              <Input
                id="location"
                placeholder="e.g., New York, NY"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="basePrice">Base Price ($) <span className="text-destructive">*</span></Label>
                <Input
                  id="basePrice"
                  type="number"
                  value={basePrice}
                  onChange={(e) => setBasePrice(Number(e.target.value))}
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="roomCount">Number of Rooms <span className="text-destructive">*</span></Label>
                <Input
                  id="roomCount"
                  type="number"
                  value={roomCount}
                  onChange={(e) => setRoomCount(Number(e.target.value))}
                  required
                />
              </div>
            </div>
          </DialogBody>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit">Add Property</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
